import { Box } from '@bechtel/gds';
import styled, { css } from 'styled-components';

export const BoxStyled = styled(Box).attrs({
  py: { sm: '400' },
  px: { sm: '400' },
  justifyContent: { sm: 'space-between' },
  alignItems: { sm: 'center' },
})`
  ${({ theme }) => css`
    width: 100%;
    border-bottom: 1px solid ${theme.colors.grey[400]};
  `}
`;

export const PriorityWeldIconStyled = styled(Box).attrs({
  alignItems: { sm: 'center' },
  justifyContent: { sm: 'center' },
})`
  ${({ theme }) => css`
    border-radius: ${theme.radii[100]};
    height: calc(${theme.spacings[500]} + ${theme.spacings[100]});
    width: ${theme.spacings[550]};
    background-color: ${theme.colors.red[500]};
  `}
`;

export const EllipseStyled = styled(Box).attrs({ mr: { sm: '200' }, alignSelf: { sm: 'center' } })`
  ${({ theme }) => css`
    width: ${theme.spacings[100]};
    height: ${theme.spacings[100]};
    background-color: ${theme.colors.grey[700]};
  `}
`;
